import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { Button } from 'rsuite'

import useDocumentRequestModal from '../Modals/hooks/useDocumentRequestModal'
import { AnalyticsSubLocation, SelectedDocumentType } from '../../utils/types/analytics'
import { Product } from '../../utils/types/Product'
import { useCyModelWithProps } from '../../services/useCyModel'
import useGlobalAnalyticsParams from '../hooks/useGlobalAnalyticsParams'

import styles from '../../styles/DocumentRequestButton.module.less'

interface DocumentRequestButtonProps {
  text: string
  Icon: FC
  product: Product
  selectedDocument?: SelectedDocumentType
}

const DocumentRequestButton: FC<DocumentRequestButtonProps> = (props) => {
  const { Icon, text, product, selectedDocument } = props

  const [globalAnalyticsParams, setGlobalAnalyticsParams] = useGlobalAnalyticsParams()
  const { t } = useTranslation('modals')

  const { SingleProductStandards } = AnalyticsSubLocation
  const openDocumentRequestModal = useDocumentRequestModal({
    analyticsLocation: SingleProductStandards,
    product,
  })

  useCyModelWithProps('SingleProduct', {
    openDocumentRequestModal,
  })

  const handleClick = () => {
    if (selectedDocument?.value) {
      setGlobalAnalyticsParams({
        ...globalAnalyticsParams,
        selectedDocument,
      })
    }
    openDocumentRequestModal()
  }

  return (
    <Button
      onClick={handleClick}
      className={styles['document-request-button']}
      appearance="ghost"
    >
      <span className={styles['icon-container']}>
        <Icon />
      </span>
      <span>{t(text)}</span>
    </Button>
  )
}

export default DocumentRequestButton
